import React from "react";

const Form24 = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              fill={fill}
              d="m25.1 33.9 8.9-8.872h-8.9V33.9ZM16.3 13.265l3.3-4.586v4.586h-3.3Z"
        />
        <path className="u_fill"
              fill={fill}
              d="M32.2 2H3.8C2.8 2 2 2.798 2 3.794v28.412C2 33.202 2.8 34 3.8 34h17.8V23.034c.1-.797.7-1.495 1.5-1.495H34V3.794C34 2.798 33.2 2 32.2 2ZM13 17.053H5.1v-1.495L9 11.57c.5-.498.8-.997 1.1-1.396.2-.398.3-.897.3-1.295 0-.499-.2-.997-.5-1.197-.4-.299-.9-.399-1.5-.399-.5 0-1 .1-1.5.3-.5.199-1 .498-1.5.897l-.7-1.595c.5-.399 1-.698 1.8-.997.8-.3 1.4-.399 2.2-.399 1.2 0 2.2.3 2.9.798.7.498 1 1.296 1 2.392 0 .698-.2 1.396-.5 1.994-.3.598-.9 1.296-1.6 1.994l-2.6 2.592H13v1.794Zm10.3-2.193h-1.7v2.193h-2V14.86h-5.2v-1.495L20 5.688h1.7v7.577h1.7v1.595h-.1Zm-16.1.997.6-.499h-.6v.499Z"
        />
    </svg>
);

export default Form24;